import { isbot } from 'isbot';

export const isUserAgentBot = (userAgentString: string) => {
  if (userAgentString?.includes?.('chrome-lighthouse')) {
    return false;
  }

  return isbot(userAgentString);
};

export const isChatGPTBrowserSession = (headers: Record<string, string | undefined>) => {
  // Check both original case and lowercase versions since HTTP headers are case-insensitive
  const signature = headers.signature || headers.Signature;
  const signatureAgent = headers['signature-agent'] || headers['Signature-Agent'];

  // Enhanced validation: signature must start with "sig1=" and have content after
  const hasValidSignature = signature && /^sig1=.+$/.test(signature);
  const hasValidAgent = signatureAgent?.includes('https://chatgpt.com');

  return !!(hasValidSignature && hasValidAgent);
};
